export default __webpack_public_path__ + "static/media/eliezer.c8ee87c3.png";